import React from 'react';
import { ColumnActions, ActionItemColors } from 'components/Table';
import { FORMATS, STATUS_VALUES } from 'helper/const';
import {
  renderStandardColumn,
  renderTagColumn,
  renderNameColumn,
} from 'utils/table';
const actionLabelMapping = {
  [STATUS_VALUES.INVITE_SENT]: 'Resend Invite',
  [STATUS_VALUES.ACTIVE]: 'Reset Password',
  [STATUS_VALUES.PENDING_APPROVAL]: 'Approve User',
};
const actionColorMapping = {
  [STATUS_VALUES.ACTIVE]: ActionItemColors.RED,
  [STATUS_VALUES.INVITE_SENT]: ActionItemColors.BLUE,
  [STATUS_VALUES.PENDING_APPROVAL]: ActionItemColors.GREEN,
};
const ACTION_ALLOWED_STATUSES = [
  STATUS_VALUES.ACTIVE,
  STATUS_VALUES.INVITE_SENT,
  STATUS_VALUES.PENDING_APPROVAL,
];
const orderColumns = onAction => {
  return [
    {
      title: 'Name',
      dataIndex: 'name',
      render: renderNameColumn,
      width: 160,
      sorter: true,
      defaultSortOrder: 'ascend',
    },
    {
      title: 'Email Address',
      dataIndex: 'email',
      render: renderStandardColumn,
      width: 160,
      sorter: true,
    },
    {
      title: 'Phone Number',
      dataIndex: 'phone_number',
      render: value => renderStandardColumn(value, FORMATS.TABLE_PHONE),
      width: 160,
      sorter: true,
    },
    {
      title: 'Role',
      dataIndex: 'role_name',
      render: renderStandardColumn,
      width: 150,
      sorter: true,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      render: (value, record) => {
        return renderTagColumn(value, record, () => {});
      },
      width: 130,
      sorter: true,
    },
    {
      title: '',
      width: 50,
      render: (_value, record) => {
        if (!ACTION_ALLOWED_STATUSES.includes(record.status)) {
          return null;
        }
        const actions = [
          {
            label: <span>{actionLabelMapping[record.status]}</span>,
            props: {
              onClick: () => {
                onAction(record);
              },
            },
          },
        ];

        return (
          <ColumnActions
            trigger={['click']}
            actions={actions}
            isBorderLastItem
            lastItemColor={actionColorMapping[record.status]}
          />
        );
      },
    },
  ];
};
export { orderColumns };
